export default {
  device: null,
  devices: [],
  totalDevices: 0,
  connectedDevices: []
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/state.js